import type { Maybe } from '@pylot-data/pylotschema'
import { TFunction } from 'react-i18next'

// TODO: move to config or reusable function/hook
enum CurrencySymbol {
    USD = '$',
    GBP = '£',
    EUR = '€'
}

export function getCurrencySymbol(code?: Maybe<string>): CurrencySymbol {
    let currencySymbol
    switch (code) {
        case 'USD':
            currencySymbol = CurrencySymbol.USD
            break
        case 'GBP':
            currencySymbol = CurrencySymbol.GBP
            break
        case 'EUR':
            currencySymbol = CurrencySymbol.EUR
            break
        default:
            currencySymbol = CurrencySymbol.USD
            break
    }
    return currencySymbol
}

export const formatPriceLabel = (
    t: TFunction<string[]>,
    label?: Maybe<string>,
    currencyCode?: Maybe<string>
): string => {
    if (typeof label !== 'string' || !label.includes('-')) {
        return String(label)
    }
    const symbol = getCurrencySymbol(currencyCode)
    const price = (value: string) => {
        const numberValue = parseFloat(value)
        if (isNaN(numberValue)) {
            return value
        }
        const formattedValue = numberValue.toLocaleString('es-CL', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })
        return `${symbol}${formattedValue}`
    }
    const priceRange = label.split('-')
    if (['*', '0'].includes(priceRange[0])) {
        return `Hasta ${price(priceRange[1])} ${t('toolbar|or less')}`
    } else if (priceRange[1] === '*') {
        return `Desde ${price(priceRange[0])}`
    } else {
        return `${price(priceRange[0])} - ${price(priceRange[1])}`
    }
}
